import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid, Field } from 'nallian-shared-ui/lib/components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import {
  SelectFieldValueComponent,
  CheckBoxFieldValueComponent,
} from 'nallian-shared-ui/lib/components/redux-form-semantic-ui';
import { FormModal } from 'nallian-shared-ui/lib/modules';
import lookupService from 'nallian-shared-ui/lib/hoc/lookupService';
import { generateErrorsForRequiredFields } from '../../../app/lib/validationHelper';
import ReadOnlyfieldValueComponent from '../../../app/components/ReadOnlyFieldValueComponent';
import apiRoutes from '../../../../app/api/routes';
import { COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE } from '../../constants';

const REQUIRED_FIELDS = ['identificationCodeTypeTag'];
const FORM_NAME = 'communityIdentificationCodeTypeForm';

const validate = values => {
  let errors = {};
  errors = generateErrorsForRequiredFields(REQUIRED_FIELDS, values, errors);

  return errors;
};

const TypeForm = ({
  submitProcessing,
  dataLoading,
  data,
  returnRoute,
  onSubmit,
  header,
  editMode,
  identificationCodeTypesLookupFetch,
}) => {
  const { t } = useTranslation();

  const communityIdCodeTypes = useSelector(state =>
    get(state, `repository.${COMMUNITY_IDENTIFICATION_CODE_TYPES_RESOURCE}.value`, [])
  );

  const typeOptions = useMemo(
    () =>
      (identificationCodeTypesLookupFetch.value || [])
        .filter(type => editMode || !communityIdCodeTypes.find(c => c.type.tag === type.tag))
        .map(type => ({
          key: type.tag,
          value: type.tag,
          text: type.name,
        })),
    [editMode, identificationCodeTypesLookupFetch.value, communityIdCodeTypes]
  );

  return (
    <FormModal
      closeIcon
      header={header}
      dataLoading={dataLoading}
      submitProcessing={submitProcessing}
      onSubmit={onSubmit}
      data={data}
      t={t}
      validate={validate}
      form={FORM_NAME}
      cancelRoute={returnRoute}
      saveButtonIcon="save"
      saveButtonContent={t('save')}
      cancelButtonContent={t('cancel')}
    >
      <Grid>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            fluid
            label={t('identificationCodeType')}
            name="identificationCodeTypeTag"
            valueComponent={editMode ? ReadOnlyfieldValueComponent : SelectFieldValueComponent}
            options={typeOptions}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
        <Grid.Column mobile={8} tablet={8} computer={8}>
          <Field
            fluid
            toggle
            label={t('isRequired')}
            name="isRequired"
            valueComponent={CheckBoxFieldValueComponent}
            disabled={submitProcessing || dataLoading}
          />
        </Grid.Column>
      </Grid>
    </FormModal>
  );
};

TypeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  dataLoading: PropTypes.bool,
  submitProcessing: PropTypes.bool,
  header: PropTypes.string.isRequired,
  returnRoute: PropTypes.string.isRequired,
  identificationCodeTypesLookupFetch: PropTypes.object.isRequired,
  data: PropTypes.object,
  editMode: PropTypes.bool,
};

TypeForm.defaultProps = {
  dataLoading: false,
  submitProcessing: false,
  data: {},
  editMode: false,
};

export default lookupService({
  resource: 'identificationCodeTypesLookup',
  url: apiRoutes.identificationCodeTypes(),
})(TypeForm);
